var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcButtonFavouriteRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 20.2752L3.4772 11.4983C2.72989 10.765 2.23542 9.81284 2.06542 8.77976C1.89543 7.74667 2.05873 6.68632 2.53169 5.75226C2.89632 5.04464 3.42219 4.43265 4.06686 3.96567C4.71153 3.49869 5.45696 3.18979 6.24298 3.0639C7.02899 2.93802 7.83359 2.99867 8.59185 3.24097C9.35012 3.48326 10.0408 3.90039 10.6082 4.45874L11.9997 5.72775L13.3912 4.45874C13.9586 3.90039 14.6493 3.48326 15.4075 3.24097C16.1658 2.99867 16.9704 2.93802 17.7564 3.0639C18.5424 3.18979 19.2878 3.49869 19.9325 3.96567C20.5772 4.43265 21.1031 5.04464 21.4677 5.75226C21.9406 6.68632 22.104 7.74667 21.934 8.77976",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5426 18.4572L21.4574 13.5424M16.5426 13.5424L21.4574 18.4572",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcButtonFavouriteRemove);
export default __webpack_public_path__ + "static/media/ic_button_favourite_remove.dbb920ac675d06161d27810d29179d90.svg";
export { ForwardRef as ReactComponent };